import React from 'react';
import { Outlet } from 'react-router-dom';

import './Business.styles.scss';

const BusinessRouter: React.FC = () => {
  return (
    <div className="business-router">
      <Outlet />
    </div>
  );
};

export default BusinessRouter;
